// =============================================================================
// 404 NOT FOUND PAGE COMPONENT
// =============================================================================

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar, Footer } from '@/components/Layout';
import { ContentRenderer } from '@/components/ContentRenderer';
import { SEOHead } from '@/components/SEO';
import { notFoundPageComponents } from '@/data/legalPageContent';
import { navItems, footerLinks, socialLinks } from '@/data/homeContent';
import { seoData } from '@/data/seoData';
import { useNotFoundStatus } from '@/hooks/useHttpStatus';
import { analytics } from '@/services/analytics';

export const NotFoundPage: React.FC = () => {
  const location = useLocation();
  const seo = seoData.notfound;
  
  // Set HTTP 404 status code for proper SEO and server responses
  useNotFoundStatus();
  
  // Track 404 errors
  useEffect(() => {
    analytics.track404Error(location.pathname);
  }, [location.pathname]);
  
  return (
    <div className="not-found-page">
      <SEOHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        noIndex={seo.noIndex}
      />
      
      <Navbar 
        brand="Awani"
        navItems={navItems}
        showThemeSwitcher={true}
      />
      
      <main className="main-content">
        <ContentRenderer components={notFoundPageComponents} />
      </main>
      
      <Footer
        brand="Awani"
        description="Luxury alpaca wool clothing made from organic fibers. Handcrafted by Peruvian artisans in the Sacred Valley. Sustainable high-end fashion."
        links={footerLinks}
        socialLinks={socialLinks}
      />
    </div>
  );
};

